import './App.css'
import LoginPage from './Pages/LoginPage/LoginPage';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const theme = createTheme()

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <LoginPage />
      <ToastContainer 
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover 
        transition={Slide}
        theme={'colored'}
        />
    </ThemeProvider>
  )
}


export default App